import { tracking } from '@iwoca/frontend-tracking-library';

import { useOnce } from '../../../hooks/useOnce';

export const useTrackCustomersPageView = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  return useOnce({
    conditionFn: enabled,
    fn: () => tracking.ampli.customersPagePageViewed(),
  });
};
